var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ppv-chip",class:[
    _vm.variantClass,
    { selected: _vm.selected, 'ppv-chip--icon': !!_vm.icon || _vm.hasDefaultSlot },
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('v-icon',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }